import { StyleSheet, View } from 'react-native';
import Colors from 'src/core/utils/Colors';
import Dimens from 'src/core/utils/Dimens';
import SvgIcon from 'src/presentation/components/atoms/SvgIcon';
import { SvgIconType } from '@thermenresorts/icons';

interface Props {
	size: number;
}

function GreenCheckmark({ size = Dimens.size50 }: Props) {
	return (
		<View style={[styles.badge, { width: size, height: size }]}>
			<SvgIcon name={SvgIconType.check} size={size / 2} tintColor={Colors.white} />
		</View>
	);
}

const styles = StyleSheet.create({
	badge: {
		alignSelf: 'flex-start',
		backgroundColor: Colors.green,
		alignItems: 'center',
		justifyContent: 'center',
		borderRadius: Dimens.borderRadiusPill,
	},
});

export default GreenCheckmark;
